export default __webpack_public_path__ + "static/media/user_guide3.5e31f0b4.png";